<template lang='pug'>
.market-container
    .item-container
        imgBox.list(v-for="(item,index) in data" :key="index" :name="item.name" :img="item.img" @click.native="$router.push({name:'marketDetail',params:{marketId:item.id}})")
</template>

<script>
import imgBox from './components/imgbox'
import { getDataHierarchies } from '@custouch/proxy-use'
import { getCmsStr } from './levelTitle'
export default {
    name:'market',
    data(){
        return {
            data:[],
        }
    },
    components:{
        imgBox
    },
    async created(){
        const cms = getCmsStr({mId: this.$route.meta.mId})
        this.$root.$emit('pageview',{cms})
        this.$root.$emit('action',{name:this.$route.name})
        const { module } = window.env.VITE_DATA
        const data = await getDataHierarchies(module.market)
        this.data = data.reduce((pre,cur)=>{
            pre.push(Object.assign({},{id:cur.id},cur.detail))
            return pre
        },[])
    }

}
</script>

<style scoped lang='less'>
.item-container{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-left:1rem;
    padding-right:1rem;
    .list{
        margin-bottom:1.2rem;
    }
}
</style>